export default function reorderColumn(
  draggedColumnId: string,
  targetColumnId: string,
  columnOrder: string[],
): string[] {
  const draggedColumnIndex = columnOrder.indexOf(draggedColumnId);
  const targetColumnIndex = columnOrder.indexOf(targetColumnId);

  const withoutDragged = columnOrder.filter(
    (_, index) => index !== draggedColumnIndex,
  );

  const reorderedColumns = withoutDragged.flatMap((columnId, index) =>
    index === targetColumnIndex ? [draggedColumnId, columnId] : [columnId],
  );

  return reorderedColumns;
}
